import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { extractDate } from "../../../Components/Functions/date.fun";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const CnFInventoryTable = ({
  data,
  currentPage,
  itemsPerPage,
  setRefresh,
  refresh,
}) => {
  const tableHead = [
    "Sr.",
    "Photo",
    "Item Name",
    "Date",
    "SKU",
    "Quantity",
    "Update",
    "Actions"
  ];
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/farm-cnf-plants-inventory/view/${id}`);
  };

  const [quantities, setQuantities] = useState(
    data?.map((item) => item?.quantity ?? "")
  );
  useEffect(() => {
    setQuantities((data ?? []).map((item) => item?.quantity ?? ""));
  }, [data]);
  const handleQuantityChange = (index, value) => {
    const numericValue = value.replace(/[^\d]/g, '');
    const updatedQuantities = [...quantities];
    updatedQuantities[index] = numericValue !== '' ? Number(numericValue) : '';
    setQuantities(updatedQuantities);
  };

  const handleUpdate = (id, quantity) => {
    // setRefresh(true);
    performRequest(
      "PATCH",
      `/pmg/cf-inventorys/update-cf-inventorys/${id}`,
      {quantity:parseInt(quantity)}
    )
      .then((res) => {
        if (res.status === 204) {
          Toast("success", "Inventory deleted successfully!");
          setRefresh(!refresh);
        }else if(res.status === 200){
          Toast("success", "Inventory Updated successfully!");
        }  else {
          Toast("error", "Error while getting data!");
        }
        // setRefresh(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  // const DeleteInventory = (itemId) => {
  //   performRequest(
  //     "DELETE",
  //     `/pmg/cf-inventorys/delete-cf-inventorys/${itemId}`
  //   )
  //     .then((res) => {
  //       if (res.status === 204) {
  //         Toast("success", "Inventory deleted successfully!");
  //       } else {
  //         Toast("error", "Error while deleting");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     });
  // };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td style={{ maxWidth: "10px" }}>
                  {item?.category === "plant" ? (
                    <img
                      src={item?.pmg_plant?.agronomyWikiUpdate?.image}
                      alt={item?.pmg_plant?.agronomyWikiUpdate?.image}
                      width="30"
                    />
                  ) : (
                    <img
                      src={item?.pmg_accessory?.photo}
                      alt={item?.pmg_accessory?.photo}
                      width="30"
                    />
                  )}
                </td>
                <td>
                  {item?.category === "plant"
                    ? item?.pmg_plant?.agronomyWikiUpdate?.name
                    : item?.pmg_accessory?.name}
                </td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>
                  <b>
                    {item?.category === "plant"
                      ? item?.pmg_plant?.plantSKU
                      : item?.pmg_accessory?.accSKU}
                  </b>
                </td>
                {/* <td>{item?.quantity || "N/A"}</td> */}
                <td style={{width:"12%"}}>
                  <input type="text" className='form-control' 
               value={quantities[index]}
               onChange={(e) => handleQuantityChange(index, e.target.value)}
               placeholder="Enter Quantity"
                />
                
                </td>
                <td>
                  <div className="btn-list">
                    <button
                      className="btn btn-sm px-3 btn-primary"
                    
                      onClick={() => handleUpdate(item?.id, quantities[index])}
                    >
                       Update
                    </button>
                  </div>
                </td>
                <td>
                  <CustomViewButton onClick={() => goToView(item?.id)}></CustomViewButton>
                </td>
                {/* <td>
                  <div className="btn-list">
                    <button
                      className="btn btn-sm btn-danger px-3"
                      onClick={() => DeleteInventory(item?.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CnFInventoryTable;
